import React from 'react';
import { ControlledDateTimePickerContext } from '../../ControlledDateTimePickerCTX.js';
import { StyledPickersIconsWrapperGrid } from '../Styleds.js';
import { CalendarWithTimeWheel } from './CalendarWithTimeWheel/CalendarWithTimeWheel.js';
import { Calendar } from './Calendar/Calendar.js';
import { TimeWheel } from './TimeWheel/TimeWheel.js';

export const PickersIcons = (): JSX.Element => {
  const {
    hideDatePicker,
    hideTimePicker,
    hideDateTimePicker,
    isControllerOnly,
    props: { hasError },
  } = React.useContext(ControlledDateTimePickerContext);

  return (
    <StyledPickersIconsWrapperGrid hasError={hasError} isControllerOnly={isControllerOnly}>
      {!hideDatePicker && hideTimePicker && hideDateTimePicker ? <Calendar /> : null}
      {hideDatePicker && !hideTimePicker && hideDateTimePicker ? <TimeWheel /> : null}
      {hideDatePicker && hideTimePicker && !hideDateTimePicker ? <CalendarWithTimeWheel /> : null}
    </StyledPickersIconsWrapperGrid>
  );
};
